import { TableBodyProps, TableHeadProps, TablePaginationProps, TableProps, TableRowProps } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import PaginationAction from './components/PaginationAction';
import settings from './services/settings';

interface IThemeColor {
  name: string;
  hex: string;
}

export const ThemeColorPresets: IThemeColor[] = [
  { name: 'Elise Violet', hex: '#665DD6' },
  { name: 'Charlie Green', hex: '#004344' },
  { name: 'Jamie Blue', hex: '#0075A1' },
  { name: "Louie's Future Black", hex: '#222222' },
];
class Themes {
  getTheme(colorHex?: string): ThemeOptions {
    const mainColor = colorHex || settings.getThemeColor();
    const darkMode = settings.getDarkMode();

    return createMuiTheme({
      palette: {
        type: darkMode ? 'dark' : 'light',
        primary: {
          main: mainColor,
        },
      },
      overrides: {
        MuiTabs: {
          root: {
            borderBottom: '1px solid #e8e8e8',
          },
          indicator: {
            backgroundColor: mainColor,
          },
        },
        MuiTab: {
          root: {
            minWidth: '6.875rem !important',
            whiteSpace: 'nowrap',
            '&$selected': {
              color: mainColor,
            },
          },
          wrapper: {
            fontSize: 16,
            textTransform: 'none',
            letterSpacing: 'normal',
          },
          textColorPrimary: {
            color: '#999',
          },
          textColorInherit: {
            color: '#999',
          },
        },
        MuiTableCell: {
          root: {
            padding: '8px 16px 8px',
            fontSize: '0.8125rem',
          },
          head: {
            padding: '16px',
            lineHeight: '1rem',
            fontSize: '0.75rem',
            fontWeight: 500,
            opacity: 0.54,
            // color: 'rgba(0,0,0, 0.54)',
          },
        },
        MuiChip: {
          sizeSmall: {
            height: 21,
            borderRadius: 3,
          },
          labelSmall: {
            paddingLeft: 6,
            paddingRight: 6,
            fontSize: 10,
            letterSpacing: 'normal',
            fontWeight: 500,
          },
        },
        MuiTypography: {
          h4: {
            fontSize: '1.875rem',
          },
          h6: {
            fontSize: '1.125rem',
          },
          body1: {
            fontSize: 15,
          },
          body2: {
            fontSize: 13,
          },
        },
        MuiInputBase: {
          input: {
            fontSize: 14,
          },
        },
        MuiButton: {
          root: {
            letterSpacing: 'normal',
            textTransform: 'none',
          },
          text: {
            color: '#aaa',
          },
          textPrimary: {
            color: mainColor,
          },
        },
        MuiFormControl: {
          marginDense: {
            marginTop: 4,
            marginBottom: 4,
          },
        },
        MuiTableRow: {
          root: {
            textDecoration: 'none',
          },
        },
      },
      props: {
        MuiTable: {
          component: 'div',
        } as Partial<TableProps>,
        MuiTableBody: {
          component: 'div',
        } as Partial<TableBodyProps>,
        MuiTableCell: {
          component: 'div',
        },
        MuiTableHead: {
          component: 'div',
        } as Partial<TableHeadProps>,
        MuiTableRow: {
          component: 'div',
        } as Partial<TableRowProps>,
        MuiTablePagination: {
          component: 'div',
          ActionsComponent: PaginationAction,
          labelRowsPerPage: null,
          labelDisplayedRows: () => null,
          rowsPerPageOptions: [10, 20, 50],
        } as Partial<TablePaginationProps>,
      },
    });
  }
}

export default new Themes();
